import { icon, label } from "../../../config";

/**
 * Views for queue grids for Tab switch on Queue page
 */

export const views = [
    {
        label: label.LIST_VIEW,
        selected: true,
        component: 'QueueTasks'
    },
    {
        label: label.DASHBOARD_VIEW,
        selected: true,
        component: 'DashBoard'
    },
    {
        label: label.WORKSPACE_CANVAS,
        selected: true,
        component: 'WorkspaceConnect'
    },

]

export const kendoViewList = [
    {
        text: "List View",
        selected: true,
        id: 0,
        label: label.GRID,
        class: "list-view",
    },
    {
        text: label.STREAM,
        selected: false,
        icon : "STREAM_ICON",
        id: 1,
        label: label.STREAM,
        class: "board"
    },
    {
        text: label.WORKSPACE_CANVAS,
        selected: true,
        icon : "TEAM_CONNECT",
        id: 2,
        label:  label.TEAM_CONNECT ,
        class: "cloud",
    },
];

export const DUE_DATE_FILTER = {
    DUE_TODAY: "Tasks Due Today",
    DUE_TOMORROW: "Tasks Due Tomorrow",
    ALL_TASKS_DUE: "All Tasks",
    DUE_TASKS: "Tasks Due in ",
}

export const selectedtask = ['Task Id', 'Due Date', 'Priority', 'Teams', 'Tags','Assignee']
